
export const cartShowCount = (value) => {
    const c = $(".cartCount");
    let prevCount = parseInt(c.attr("data-cartcount") ?? "0");
    let count = prevCount + value;
    c.attr("data-cartcount",count);
    if ( count <= 0 ){
        c.removeClass('popup-count-number')
    }else{
        c.addClass('popup-count-number')
        if ( count > 99 ){
            c.attr("data-count","99+");
        }else{
            c.attr("data-count",count);
        }
    }
};

export const orderShowCount = (value) => {
    const c = $("#orderCount");
    let prevCount = parseInt(c.attr("data-orderCount") ?? "0");
    let count = prevCount + value;
    if ( !c.hasClass("order-list") ){
        if ( count > 0 ){
            c.addClass('order-list')
        }
    }
    c.attr("data-orderCount",count);
    if ( count > 1000 ){
        c.attr("data-count","1000+");
    }else{
        c.attr("data-count",count);
    }
}